import { Injectable } from '@angular/core';
import { ShowInactiveService } from '../../base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from '../../base/shared/syncfusion/adaptor-service.interface';
import { Observable, of, throwError } from 'rxjs';
import {
  ExecuteZoneDeviceCommandDTO,
  FilterDTO,
  FilterOperator,
  PagedResultDTOOfZoneDeviceDTO,
  SortDirection,
  ZoneDeviceClient,
} from '../../base/models/models.swagger.generated';
import { ClientService } from '../../base/services/client/client.service';
import { catchError, map } from 'rxjs/operators';
import { ErrorType } from '../../core/routing/error-types';
import { ToastService } from '../../base/services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class DeviceInteractionService extends ShowInactiveService implements IAdaptorService {

  public zoneId: number;

  constructor(private clientService: ClientService,
              private toastService: ToastService,
              private zoneDeviceClient: ZoneDeviceClient) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfZoneDeviceDTO> {
    if (!this.clientService.selectedClient) {
      return of(null);
    }

    if (!filters) {
      filters = [];
    }
    filters.push(new FilterDTO({isComplex: false, field: 'enabled', operator: FilterOperator.Equal, value: true.toString()}));
    if (this.zoneId) {
      filters.push(new FilterDTO({isComplex: false, field: 'zone.id', operator: FilterOperator.Equal, value: '' + this.zoneId}));
    }

    return this.zoneDeviceClient.searchDevices(this.clientService.selectedClient.id, filters, 0, 0, sortBy, sortDirection)
      .pipe(
        map(pagedResult => {
          const items = pagedResult.items.filter(i => !!i.supportedDevicePositions
                                                    && i.supportedDevicePositions.length > 0
                                                    && i.supportedDevicePositions.find(p => !!p.supportedCommands && p.supportedCommands.length > 0));

          items.forEach(i => {
            let dev = (i as any);
            dev.supportedCommands = i.supportedDevicePositions.find(p => p.position === i.currentDevicePosition)?.supportedCommands;
            if (!dev.supportedCommands && i.currentDevicePosition == null) {
              // look for 'unknown' position commands as a fallback
              dev.supportedCommands = i.supportedDevicePositions.find(p => p.position.toLowerCase() === 'unknown')?.supportedCommands;
            }
            // make sure supported commands is not null
            if (!dev.supportedCommands) {
              dev.supportedCommands = [];
            }
          });

          if (skip != null && take != null) {
            return new PagedResultDTOOfZoneDeviceDTO({
              items: items.slice(skip, skip + take),
              totalNumberOfItems: items.length,
            });
          }

          return new PagedResultDTOOfZoneDeviceDTO({
            items,
            totalNumberOfItems: items.length,
          });

        }),
      );
  }

  public addRecord(data: any): Observable<any> {
    return undefined;
  }

  public deleteRecord(id: number): Observable<any> {
    return undefined;
  }

  public updateRecord(data: any): Observable<any> {
    return undefined;
  }

  public executeDeviceCommand(dto: ExecuteZoneDeviceCommandDTO): Observable<void> {
    return this.zoneDeviceClient.executeDeviceCommand(dto)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }
}
